import { Hint, Label } from "Components/TextContext/commonComponentEnums";

import { StyledAlert } from "App/global-style";
import { AlertType } from "Components/Form/Alert";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { PepFormValues } from "./interfaces";

interface Props {
  formProps: FormikProps<PepFormValues>;
}

export const Pep = ({ formProps }: Props): React.ReactElement => {
  const { getText } = TextManager;
  return (
    <div className="data-hj-suppress">
      <RadioButtonTrueFalse
        direction="vertical"
        name="pep"
        id="pep"
        label={getText(Label.PEP)}
        hint={getText(Hint.PEP)}
        error={getError("pep", formProps)}
        options={getYesOrNoOptions("yes", "no")}
      />
      {formProps.values.pep === BooleanFormType.TRUE && (
        <StyledAlert
          title={getText(
            "citizenshippepform.alerttitle.cantofferinsuranceonline",
          )}
          type="error"
          fluid
          alertId="pep"
          alertType={AlertType.STOPPER_ALERT}
        >
          <p>{getText("citizenshippepform.alertdescription.pep")}</p>
        </StyledAlert>
      )}
    </div>
  );
};
